import { useStore } from "../../state/state.ts";
import Tacho from "../tacho.tsx";

export default function StatisticsEnergiesparklasse() {
    const energy_efficiency_class_adjusted_level = useStore((state)=>state.energy_efficiency_class_adjusted_level);
    const energy_efficiency_class_planned_level = useStore((state)=>state.energy_efficiency_class_planned_level);
  
  return (
    <Tacho label={"Effizienzklasse"} now={energy_efficiency_class_adjusted_level} future={energy_efficiency_class_planned_level} />
  )
}